import {Static, Type} from '@sinclair/typebox';
import {IQuestionAndPrompts} from '../../core/state/model/CompetitionModel';
import {
  TAiPrompt,
  TComp,
  TCompPrivate,
  TLeaderboard,
} from './FirestoreInterfaces';

export const TLocalLeaderboard = Type.Omit(TLeaderboard, ['vendor', 'comps']);
export type TLocalLeaderboard = Static<typeof TLocalLeaderboard>;

export const TLocalCompPrivate = Type.Omit(TCompPrivate, ['notificationsSent']);
export type TLocalCompPrivate = Static<typeof TLocalCompPrivate>;

export const TLocalComp = Type.Composite([
  Type.Omit(TComp, ['shortUrl', 'leaderboards']),
  Type.Object({
    questions: Type.Array(IQuestionAndPrompts),
    leaderboardConfigurations: Type.Array(TLocalLeaderboard),
    privateData: TLocalCompPrivate,
    compPrompt: Type.Optional(TAiPrompt),
  }),
]);
export type TLocalComp = Static<typeof TLocalComp>;

export const getLocalQuestionImageFileName = (index: number) =>
  `question-${index + 1}`;

export const getLocalQuestionLinkFileName = (index: number) =>
  `question-link-${index + 1}`;

export const getLocalQuestionPublisherFileName = (index: number) =>
  `question-publisher-${index + 1}`;

export const getLocalQuestionAuthorFileName = (index: number) =>
  `question-author-${index + 1}`;

export const getLocalLeaderboardImageFileName = (key: string) =>
  `leaderboard-${key}`;

export const getLocalLeaderboardPrizeImageFileName = (
  key: string,
  index: number,
) => `leaderboard-${key}-prize-${index + 1}`;

export const getQuestionNumberFromImageName = (name: string) => {
  const index = name.includes('.') ? name.lastIndexOf('.') : name.length;
  const digits = name.substring(0, index).match(/\d+/g);
  if (digits?.length !== 1) {
    throw new Error(`Invalid image name: ${name}`);
  }
  return Number(digits[0]);
};
